import { http } from "@/utils/http"

let initAuthPromise = null

function normalizeAuthUser(user) {
    if (!user) {
        return null
    }

    const normalizedUser = { ...user }
    if (Object.prototype.hasOwnProperty.call(normalizedUser, "passcode")) {
        normalizedUser.hasPasscode = Boolean(normalizedUser.passcode)
        delete normalizedUser.passcode
    }

    return normalizedUser
}

const state = {
    token: "",
    user: null,
    authInitialized: false,
}

const getters = {
    authenticated: (state) => {
        return !!state.user && state.user.hasPasscode !== false
    },
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
        localStorage.removeItem("AUTH_TOKEN")
    },

    SET_USER: (state, data) => {
        state.user = data
    },
    SET_AUTH_INITIALIZED: (state, data) => {
        state.authInitialized = data
    },
}

const actions = {
    getMe: async ({ commit }) => {
        let response = await http.get("/auth/me")
        const result = normalizeAuthUser(response.data.result)
        commit("SET_TOKEN", "cookie-session")
        commit("SET_USER", result)
    },
    login: async ({ commit }, formData) => {
        const requestLogin = (cookieOnly) => http.post(
            "/auth/login",
            {
                ...formData,
                cookie_only: cookieOnly,
            },
            { withCredentials: cookieOnly }
        )

        const shouldRequestCookieSession = Boolean(formData.passcode)
        let response = await requestLogin(shouldRequestCookieSession)
        const result = response.data.result
        let user = normalizeAuthUser(result.user)
        if (user && user.hasPasscode !== false && !shouldRequestCookieSession) {
            response = await requestLogin(true)
            user = normalizeAuthUser(response.data.result.user)
        }

        if (user && user.hasPasscode !== false) {
            commit("SET_TOKEN", "cookie-session")
            commit("SET_USER", user)
        } else {
            commit("SET_TOKEN", "")
            commit("SET_USER", null)
        }
        return user
    },
    savePasscode: async ({ commit }, formData) => {
        let response = await http.post("/auth/passcode", formData)
        const result = response.data.result
        const user = normalizeAuthUser(result.user)

        //  (response.data.success === true)
        commit("SET_TOKEN", result.token)
        commit("SET_USER", user)
        return
    },
    initAuth: async ({ commit, state }) => {
        if (state.authInitialized) {
            return
        }

        if (!initAuthPromise) {
            initAuthPromise = (async () => {
                try {
                    let response = await http.get("/auth/me")
                    const result = normalizeAuthUser(response.data.result)

                    commit("SET_TOKEN", "cookie-session")
                    commit("SET_USER", result)
                } catch (error) {
                    console.log("caught error login", error)
                    commit("SET_TOKEN", "")
                    commit("SET_USER", null)
                } finally {
                    commit("SET_AUTH_INITIALIZED", true)
                    initAuthPromise = null
                }
            })()
        }

        return initAuthPromise
    },
    logout: async ({ commit }) => {
        commit("SET_TOKEN", "")
        commit("SET_USER", null)
        try {
            await http.post("/auth/logout")
        } catch (error) {
            console.log("error logging out", error)
        }
    },
}

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations,
}
